import { UIChunkType } from '@myre/app-agent-domain';

import { Component, computed, input } from '@angular/core';
import { isDataUIPart } from 'ai';

import {
  type MyreUiMessagePart,
  type QuotaWarning,
} from '../../interfaces/chat.interfaces';

@Component({
  selector: 'app-quota-warning',
  standalone: true,
  templateUrl: './quota-warning.component.html',
  styleUrl: './quota-warning.component.scss',
})
export class QuotaWarningComponent {
  public readonly part = input.required<MyreUiMessagePart>();

  protected readonly _warning = computed<QuotaWarning | null>(() => {
    const part = this.part();

    if (!isDataUIPart(part) || part.type !== UIChunkType.DataQuotaWarning) {
      return null;
    }

    return { message: part.data.message, usedPercent: part.data.usedPercent };
  });

  /** Gauge width, clamped to the track since the percent arrives over the wire. */
  protected readonly _gaugePercent = computed(() =>
    Math.min(100, Math.max(0, this._warning()?.usedPercent ?? 0)),
  );
}
